import React, {MouseEvent, useState} from 'react';
import {
	Box,
	Grid,
	ListItem,
	ListItemAvatar,
	ListItemButton,
	ListItemText,
	Skeleton,
	Typography,
	styled, Paper, ImageListItem, ImageListItemBar, IconButton
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import {useTranslation} from 'react-i18next';
import socket, {IResponse} from '@sockets';
import IChannel from './IChannel';
import LoadingButton from '@mui/lab/LoadingButton';
import {Link} from 'react-router-dom';

interface IProps {
	channel: IChannel;
	onJoin: (channel: IChannel) => void;
}

export default function TopChannelItem({channel, onJoin}: IProps) {
	const [loading, setLoading] = useState(false);
	const {t} = useTranslation();
	
	const handleJoinBtnClicked = (event: MouseEvent<HTMLButtonElement>) => {
		setLoading(true);
		socket.emit('network:join_channel', channel.id, (data: IResponse<IChannel>) => {
			setLoading(false);
			if (data.success) {
				data.result.lastTime = new Date(data.result.lastTime);
				onJoin(data.result);
			} else {
				// TODO show error snack
			}
		});
	};
	
	return (
		<>
			<ImageListItem
				sx={{
					borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.grey[700],
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : 'background.paper'
				}}
				key={channel.id}
				component={Link}
				to={channel.name ? `/network/${channel.id}` : ''}
				className="w-2/12 h-auto rounded border-2">
				{
					channel.name ?
						<img
							srcSet={`${channel.image}`}
							src={`${channel.image}`}
							alt={channel.name}
							className="rounded"
							loading="lazy"
						/> :
						<Skeleton width={40} height={40} variant="rounded"/>
				}
				{/*<ImageListItemBar
				 title={
				 channel.name ?
				 <Typography sx={{
				 color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
				 fontSize: (theme) => theme.typography.fontSize
				 }} className="font-medium">{channel.name}</Typography>
				 :
				 <Skeleton className="w-3/5"/>
				 }
				 // subtitle={item.author}
				 actionIcon={
				 <IconButton
				 sx={{color: 'rgba(255, 255, 255, 0.54)'}}
				 aria-label={`info about ${channel.name}`}
				 >
				 <InfoIcon/>
				 </IconButton>
				 }
				 />*/}
			</ImageListItem>
		</>
	);
}
